import { cn } from '@/lib/ui/utils';
import type { ReactNode } from 'react';

type CmsWorkspaceLayoutProps = {
  panel: ReactNode;
  content: ReactNode;
  className?: string;
  panelClassName?: string;
  contentClassName?: string;
};

export function CmsWorkspaceLayout({
  panel,
  content,
  className,
  panelClassName,
  contentClassName,
}: CmsWorkspaceLayoutProps) {
  return (
    <div className={cn('cms-workspace-layout', className)}>
      <div className={cn('cms-workspace-layout-panel', panelClassName)}>
        {panel}
      </div>
      <div className={cn('cms-workspace-layout-content', contentClassName)}>
        {content}
      </div>
    </div>
  );
}
